export enum EnumKeyboardAction {
  NAVIGATE_DOWN = 'NAVIGATE_DOWN',
  NAVIGATE_UP = 'NAVIGATE_UP',
  SELECT_ITEM = 'SELECT_ITEM',
  CLEAR_HIGHLIGHT = 'CLEAR_HIGHLIGHT',
}
